module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n	")
    ;  Util.each(widget.files, function(file) { 
    ; __append("\n\n		<img src=\"")
    ; __append(escapeFn(file.src))
    ; __append("\" width=\"")
    ; __append(escapeFn( file.width ))
    ; __append("\" class=\"img-preview\" index=\"")
    ; __append(escapeFn( file.index ))
    ; __append("\" on-click=\"showImageClicked\"/>\n\n	")
    ;  }) 
    ; __append("\n</div>")
  }
  return __output.join("");

}